<template>
  <div class="content" v-loading.fullscreen.lock="loading">
    <div class="row">
      <div class="col-xl-12">
        <div
          class="dash-head-wrap d-flex justify-content-between  align-items-start align-items-sm-center flex-column flex-sm-row">
          <div class="dash-header mb-4">
            <h2 class="text-default m-0 d-flex">Skill Certificates <img v-if="!isSafeDig" src="/signup-img/fire.svg" alt="">
            </h2>
            <!-- <p class="text-secondary">let's dive into your personalized setup guide.</p> -->
          </div>
          <div class="certi-right-area">
            <el-tooltip content="Export Certificate Data" placement="top">
              <base-button name="Export Certificate Data" class="mb-2" @click="downloadExcel" type="primary"
                data-toggle="tooltip" data-original-title="Export Certificate Data">
                Export Certificate Data
              </base-button>
            </el-tooltip>
            <el-tooltip content="Download Certificates" class="mb-2" placement="top">
              <base-button name="Download Certificate" @click="downloadCertificate" type="primary" data-toggle="tooltip"
                data-original-title="Download Certificates">
                Download Certificates
              </base-button>
            </el-tooltip>
            <el-tooltip content="View Certificates" class="mb-2" placement="top">
              <base-button type="primary" name="View Certificate" @click="viewCertificates"
                class="font-weight-normal px-4 ml-auto ml-sm-0" data-toggle="tooltip"
                data-original-title="View Certificates">
                View Certificates
              </base-button>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="card top-cardheader" v-if="editor === 'admin' || editor === 'manager'">
      <div class="row m-0">
        <div class="col-xl-4 col-md-6 p-0">
          <div class="dash-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
            <div class="card-value-box">
              <div class="card-icon-img">
                <img :src="overviewTotalCertificateIcon" />
              </div>
              <div class="card-left flex-grow-1 pl-3">
                <h5 class="font-weight-normal m-0" name="Total Employee">Total Certificates</h5>
                <span name="Total Employee">{{ totalCount }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-md-6 p-0">
          <!--                    <router-link class="nav-item" to="/company_locations">-->
          <div class="dash-card-box shadow-none border-right rounded-0 px-3 px-sm-4">
            <div class="card-value-box">
              <div class="card-icon-img">
                <img :src="overviewActiveCertificateIcon" />
              </div>
              <div class="card-left flex-grow-1 pl-3">
                <h5 class="font-weight-normal m-0" name="New employee">Active Certificates</h5>
                <span name="New employee">{{ activeCount }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-md-6 p-0">
          <div class="dash-card-box shadow-none border-0 rounded-0 px-3 px-sm-4 mb-0">
            <div class="card-value-box">
              <div class="card-icon-img">
                <img :src="overviewExpiredCertificateIcon" />
              </div>
              <div class="card-left flex-grow-1 pl-3">
                <h5 class="font-weight-normal m-0">Expired Certificates</h5>
                <span>{{ inActiveCount }}</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="certificate_detail_wrap">
      <div>
        <card class="no-border-card card-with-table" footer-classes="pt-1">
          <template slot="header">
            <div class="row align-items-center">
              <div class="col-md-6 text-left">
                <h2 class="mb-0">{{ certificate }} Certificate</h2>
              </div>
              <div class="col-md-6 text-right">
                <button type="button" class="filters-toggle-btn" :class="{ 'is-open': showContent }"
                  @click="toggleSlide">
                  <i class="fas fa-sliders-h mr-2"></i>
                  <span>{{ showContent ? 'Hide Filters' : 'Show Filters' }}</span>
                  <span v-if="activeFilterCount > 0" class="filters-badge">{{ activeFilterCount }}</span>
                </button>
              </div>
            </div>
          </template>
          <div>
            <transition name="filters-slide">
              <div v-if="showContent" class="modern-filters mb-4 mx-3">
                <div class="modern-filters__header">
                  <div class="modern-filters__title">
                    <i class="fas fa-filter"></i>
                    <span>Filters</span>
                  </div>
                  <button type="button" class="modern-filters__reset" @click="resetFilters"
                    :disabled="activeFilterCount === 0">
                    <i class="fas fa-undo-alt mr-1"></i> Reset
                  </button>
                </div>
                <div class="modern-filters__grid">
                  <div class="modern-filter">
                    <label class="modern-filter__label">Search</label>
                    <base-input v-model="searchQuery" prepend-icon="fas fa-search" placeholder="Search by name, course...">
                    </base-input>
                  </div>
                  <div class="modern-filter">
                    <label class="modern-filter__label">Company</label>
                    <el-select filterable name="Certificate Screen Company filter" class="select-primary w-100"
                      v-on:change="fetchData()" v-model="filters.location_id" placeholder="All companies"
                      :disabled="isSafeDig && includeIndividuals">
                      <el-option class="select-primary" v-for="item in locations" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    <small v-if="isSafeDig && includeIndividuals" class="modern-filter__hint">
                      Disabled while "Include individuals" is on
                    </small>
                  </div>
                  <div class="modern-filter">
                    <label class="modern-filter__label">Status</label>
                    <el-select class="select-primary w-100" v-on:change="fetchData()"
                      v-model="filters.certificateStatus" placeholder="All statuses">
                      <el-option class="select-primary" v-for="item in status" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="modern-filter" v-if="editor == 'super-admin'">
                    <label class="modern-filter__label">Certificates</label>
                    <el-select class="select-primary w-100" v-on:change="fetchData()"
                      v-model="filters.certificateType" placeholder="All certificate types">
                      <el-option class="select-primary" v-for="item in certificateTypes" :key="item.value"
                        :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="modern-filter">
                    <label class="modern-filter__label">User Type</label>
                    <el-select class="select-primary w-100" v-on:change="fetchData()" v-model="filters.userType"
                      placeholder="All users">
                      <el-option class="select-primary" v-for="item in userTypes" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="modern-filter">
                    <label class="modern-filter__label">Showing</label>
                    <el-select class="select-primary pagination-select w-100" v-model="perPage"
                      v-on:change="changePage(1)" placeholder="Per page">
                      <el-option class="select-primary" v-for="item in perPageOptions" :key="item" :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="modern-filter modern-filter--toggle" v-if="isSafeDig">
                    <label class="modern-filter__label">Individuals</label>
                    <label class="modern-toggle" :class="{ 'is-on': includeIndividuals }">
                      <input type="checkbox" v-model="includeIndividuals" @change="onIncludeIndividualsToggle($event.target.checked)" />
                      <span class="modern-toggle__track">
                        <span class="modern-toggle__thumb"></span>
                      </span>
                      <span class="modern-toggle__label">Include individuals</span>
                    </label>
                  </div>
                </div>
              </div>
            </transition>
            <div class="user-eltable table-style-normal no-header-bg">
              <el-table :data="tableData" class="certGrid" role="table" row-key="id"
                header-row-class-name="thead-light custom-thead-light" @selection-change="selectionChange">
                <el-table-column class-name="col-nowrap user-col ignore-translation" min-width="250px" label="">
                  <template slot="header">
                    <span @click="sortByColumn(0)">User
                      <i v-if="sortedColumn == 0 && order === 'asc'" class="fas fa-arrow-up text-blue linkColor" /><i
                        v-else class="fas fa-arrow-down text-blue linkColor" />
                    </span>
                  </template>
                  <template slot-scope="props">
                    <router-link :to="`add_employee?id=${props.row.employee_id}`">
                      <!-- <img src="img/theme/avatar.svg" width="45" height="45" alt="" /> -->
                      <span class="ml-2">{{ props.row.first_name + ' ' + props.row.last_name }}</span>
                    </router-link>
                  </template>
                </el-table-column>
                <el-table-column v-if="!(isSafeDig && includeIndividuals)"
                  class-name="left-align col-nowrap ignore-translation" min-width="150px" label="Location">
                  <template slot="header">
                    <span @click="sortByColumn(4)">Location
                      <i v-if="sortedColumn == 4 && order === 'asc'" class="fas fa-arrow-up text-blue linkColor" /><i
                        v-else class="fas fa-arrow-down text-blue linkColor" />
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span>{{ props.row.location }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="150px" label="">
                  <template slot="header">
                    <span @click="sortByColumn(2)">Completion Date
                      <i v-if="sortedColumn == 2 && order === 'asc'" class="fas fa-arrow-up text-blue linkColor" /><i
                        v-else class="fas fa-arrow-down text-blue linkColor" />
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span>{{ formattedDate(props.row.certificate_date) }}</span>
                  </template>
                </el-table-column>

                <el-table-column class-name="left-align col-nowrap ignore-translation" min-width="150px" label="Course">
                  <template slot="header">
                    <span @click="sortByColumn(5)">Course
                      <i v-if="sortedColumn == 5 && order === 'asc'" class="fas fa-arrow-up text-blue linkColor" /><i
                        v-else class="fas fa-arrow-down text-blue linkColor" />
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span>{{ props.row.course_name }}</span>
                  </template>
                </el-table-column>

                <el-table-column min-width="150px" label="">
                  <template slot="header">
                    <span @click="sortByColumn(3)">Expiration Date
                      <i v-if="sortedColumn == 3 && order === 'asc'" class="fas fa-arrow-up text-blue linkColor" /><i
                        v-else class="fas fa-arrow-down text-blue linkColor" />
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span>{{ formattedDate(props.row.expiration_date) }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="150px" label="Course">
                  <template slot="header">Certificate #</template>
                  <template slot-scope="props">
                    <span>#{{ props.row.certificate_no }}</span>
                  </template>
                </el-table-column>
                <el-table-column min-width="145px" class-name="td-actions" label="Action">
                  <template slot-scope="props">
                    <div class="action-wrap d-flex align-items-center " v-if="editor == 'super-admin'">
                      <div class="mr-2">
                        <el-tooltip content="Preview" placement="top" v-if="props.row.is_proctored_exam == 1">
                          <a @click.prevent="
                            getProctoredExamCertificate(
                              props.row.certificate_url
                            )
                            " data-original-title="Preview" data-toggle="tooltip">
                            <span>
                              <img class="ico-eye" src="/img/icons/common/eye_icon.svg" alt=""
                                v-if="!props.row.show_loader" />
                              <i class="text-success fas fa-spin fa-spinner" v-if="props.row.show_loader"></i>
                            </span>
                          </a>
                        </el-tooltip>
                        <el-tooltip content="Preview" placement="top">
                          <a href="javascript:void(0)" @click.prevent="
                            openCertificatePreview(
                              props.row.course_id,
                              props.row.employee_id,
                              props.row.certificate_id
                            )
                          " data-toggle="tooltip" data-original-title="Preview">
                            <span>
                              <img class="ico-eye" src="/img/icons/common/eye_icon.svg" alt="" />
                            </span></a>
                        </el-tooltip>
                      </div>
                      <div class="mr-2" v-if="props.row.is_proctored_exam == 0">
                        <el-tooltip content=" Download" placement="top">
                          <a :href="baseUrl +
                            '/downloadCourseCertificate/download/' +
                            props.row.course_id +
                            '/' +
                            props.row.employee_id +
                            '/' +
                            props.row.certificate_id
                            " data-toggle="tooltip" data-original-title="Download">
                            <span>
                              <img class="ico-download" src="/img/icons/common/download_icon.svg" alt="" />
                            </span></a>
                        </el-tooltip>
                      </div>
                      <div class="mr-2" v-if="(props.row.is_certificate_approved == 0) && (editor == 'super-admin')">
                        <el-tooltip content="Download">
                          <span @click="approveCertificate(props.row)" data-toggle="tooltip"
                            data-original-title="Approve">
                            <img class="ico-download" src="/img/icons/common/download_icon.svg" alt="" />

                          </span>
                        </el-tooltip>
                      </div>
                      <div class="mr-2" v-if="props.row.is_certificate_approved == 1">
                        <el-tooltip content="Email Certificate">
                          <span @click="emailCertificate(props.row)" data-toggle="tooltip"
                            data-original-title="Email Certificate">
                            <img class="ico-email" src="/img/icons/common/email.svg" alt="" />
                          </span>
                        </el-tooltip>
                      </div>
                      <el-tooltip content="Edit Certificate Number" placement="top">
                        <span @click="editCertificateNumber(props.row)" data-toggle="tooltip">
                          <img class="ico-eye" src="/img/icons/common/edit.svg" alt="" />
                        </span>
                      </el-tooltip>
                    </div>
                    <div class="row" v-else>
                      <div class="mr-2">
                        <el-tooltip content="Preview" placement="top" v-if="props.row.is_proctored_exam == 1">
                          <a @click.prevent="
                            getProctoredExamCertificate(
                              props.row.certificate_url
                            )
                            " data-original-title="Preview" data-toggle="tooltip">
                            <span>
                              <img class="ico-eye" src="/img/icons/common/eye_icon.svg" v-if="!props.row.show_loader"
                                alt="" />
                              <!-- <img name="Preview Proctored Exam Certificate" width="18" src="/img/icons/common/eye_icon.svg" alt="" /> -->
                              <i class="text-success fas fa-spin fa-spinner" v-if="props.row.show_loader"></i>
                            </span>
                          </a>
                        </el-tooltip>
                        <el-tooltip content="Preview" placement="top" v-if="props.row.is_certificate_approved == 1">
                          <a href="javascript:void(0)" @click.prevent="
                            openCertificatePreview(
                              props.row.course_id,
                              props.row.employee_id,
                              props.row.certificate_id
                            )
                          " data-toggle="tooltip" data-original-title="Preview">
                            <span>
                              <!-- <img width="18" src="/img/icons/common/eye_icon.svg" alt="" /> -->
                              <!-- <img class="ico-eye" src="/img/icons/common/eye_icon.svg" alt="" /> -->
                              <!-- <i name="Preview Certificate" class=""></i>  -->
                              <img class="ico-eye" src="/img/icons/common/eye_icon.svg" alt="" />
                            </span></a>
                        </el-tooltip>
                      </div>
                      <div class="mr-2" v-if="props.row.is_certificate_approved == 1">
                        <el-tooltip content="Email Certificate">
                          <span @click="emailCertificate(props.row)" data-toggle="tooltip"
                            data-original-title="Email Certificate">
                            <!-- <img width="18" src="/img/icons/common/email.svg" alt="" /> -->
                            <img class="ico-email" src="/img/icons/common/email.svg" alt="" />



                            <!-- <i class="text-success fa fa-envelope"></i> -->
                          </span>
                        </el-tooltip>
                      </div>
                      <div class="mr-2" v-if="props.row.is_certificate_approved == 1">
                        <el-tooltip content="Download">
                          <a :href="baseUrl + '/downloadCourseCertificate/download/' + props.row.course_id + '/' + props.row.employee_id + '/' + props.row.certificate_id"
                            data-toggle="tooltip" data-original-title="Download">
                            <!-- <i class="text-warning fa fa-download"></i> -->
                            <!-- <img width="18" src="/img/icons/common/download-table.svg" alt="" /> -->
                            <img class="ico-download" src="/img/icons/common/download_icon.svg" alt="" />

                          </a>
                        </el-tooltip>
                      </div>
                      <div class="col-md-12" v-if="props.row.is_certificate_approved == 0">
                        Generating Certificate...
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div slot="footer" class="
              col-12
              d-flex
              justify-content-end
              flex-wrap
            ">
            <div class="">
            </div>
            <div slot="footer" class="d-flex justify-content-end ">
              <nav v-if="pagination && tableData.length > 0">
                <div class="row">
                  <div class="col-md-12">
                    <ul class="pagination custompagination justify-content-end align-items-center">
                      <p class="p-0 m-0 mr-2">
                        Showing {{ tableData.length }} of {{ totalData }} entries
                      </p>
                      <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)"><i
                            class="fa fa-caret-left "></i>
                        </a>
                      </li>
                      <li v-for="(page, index) in pagesNumber" class="page-item"
                        :class="{ active: page == currentPage }" v-bind:key="index">
                        <a href="javascript:void(0)" @click.prevent="changePage(page)" class="page-link">{{ page }}</a>
                      </li>
                      <li class="page-item" :class="{
                        disabled: currentPage === last_page
                      }">
                        <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)"><i
                            class="fa fa-caret-right "></i></a>
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </card>
      </div>
    </div>
    <modal :show.sync="download_certificate">
      <h6 class="title title-up">Download all the certificates</h6>
      <a download :href="download_file_link" class="btn btn-success">Download</a>
    </modal>
    <modal :show.sync="isCertificateEdit">
      <h4 slot="header" style="color:#444C57" class="title title-up text-center">Edit Certificate Number</h4>
      <div class="row">
        <div class="col-12 mb-3">
          <label class="d-block"><strong>Employee Name:</strong></label>
          <span class="fw-bold">{{ selectedCertificate.first_name }}</span>
        </div>
        <div class="col-12 mb-3">
          <label class="d-block"><strong>Course Name:</strong></label>
          <span class="fw-bold">{{ selectedCertificate.course_name }}</span>
        </div>
        <div class="col-12 mb-3">
          <label class="d-block"><strong>Current Certificate Number:</strong></label>
          <span class="fw-bold">{{ selectedCertificate.certificate_no !== "" ? selectedCertificate.certificate_no : 0
            }}</span>
        </div>
        <div class="col-md-12 mb-3">
          <div class="form-group">
            <label><strong>New Certificate Number</strong></label>
            <input type="text" v-model="new_certificate_number" class="form-control" />
          </div>
        </div>
        <div class="col-12 text-right">
          <base-button type="primary" @click="updateCertificateNumber">Update</base-button>
        </div>
      </div>
    </modal>
    <modal :show.sync="showCertificatePreviewModal" :modal-classes="'certificate-preview-dialog'">
      <h4 slot="header" style="color:#444C57" class="title title-up text-center">Certificate Preview</h4>
      <iframe
        v-if="certificatePreviewUrl"
        :src="certificatePreviewUrl"
        class="certificate-preview-frame"
        title="Certificate preview"></iframe>
    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "@/components";
import serverSidePaginationMixin from "../Tables/PaginatedTables/serverSidePaginationMixin";
//import swal from 'sweetalert';
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import XLSX from "xlsx";
import moment from "moment";
import { formatDateLocal } from "@/util/dateFormatter";
import { downloadFile } from '@/util/certificateWindow';
let timeout = null;
export default {
  mixins: [serverSidePaginationMixin],
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      new_certificate_number: "",
      selectedCertificate: {},
      isCertificateEdit: false,
      showCertificatePreviewModal: false,
      certificatePreviewUrl: "",
      certificatePreviewBlobUrl: "",
      loading: false,
      baseUrl: this.$baseUrl,
      download_certificate: false,
      showContent: false, // State to control visibility
      download_file_link: "",
      isLoading: false,
      fullPage: true,
      company_id: "",
      hot_user: "",
      hot_token: "",
      config: "",
      searchQuery: "",
      course_id: "",
      tbl_data: [],
      course_name: "",
      resultGenerated: false,
      json_fields: {
        "Employee First Name": "First Name",
        "Employee Last Name": "Last Name",
        "Course Name": "Course Name",
        "Certificate Name": "Certificate Name",
        "Certificate Date": "Certificate Date",
        "Certificate Expiry Date": "Certificate Expiry Date",
      },

      json_data: [],
      locationManager: false,
      location_id: "",
      certificate_name: "",
      status: [
        {
          label: "Active Certificates",
          value: "Active Certificates",
        },
        {
          label: "Expired Certificates",
          value: "Expired Certificates",
        },
        {
          label: "Show All",
          value: "",
        },
      ],
      locations: [
        {
          label: "All",
          value: "",
          parent_id: 0,
        },
      ],
      filters: {
        certificateStatus: "Active Certificates",
        certificateType: 0,
        userType: 1,
        location_id: "",
      },
      includeIndividuals: false,
      userTypes: [
        {
          label: "All",
          value: 0,
        },
        {
          label: "Active Users",
          value: 1,
        },
        {
          label: "Inactive Users",
          value: 2,
        },

      ],
      certificateTypes: [
        {
          label: "All",
          value: 0,
        },
        {
          label: "Manual Certificate",
          value: 1
        },
      ],
      editor: "",
      interface: "",
      tableData: [],
      selectedRows: [],
      employeeUrl: [],
      courseUrl: [],
      certificate: "",
      course_ids: [],
      certificate_ids: [],
      employee_ids: [],
      totalCount: '',
      activeCount: '',
      inActiveCount: '',
      uploadedCertificateCount: '',
    };
  },
  computed: {
    isSafeDig() {
      return process.env.VUE_APP_COMPANY_NAME_FRONTEND === "safedig";
    },
    overviewTotalCertificateIcon() {
      return this.isSafeDig
        ? require("@/assets/safe-dig/svg-icons/total_certificate.svg")
        : "img/svg-icons/total_certificate.svg";
    },
    overviewActiveCertificateIcon() {
      return this.isSafeDig
        ? require("@/assets/safe-dig/svg-icons/active_certificate.svg")
        : "img/svg-icons/active_certificate.svg";
    },
    overviewExpiredCertificateIcon() {
      return this.isSafeDig
        ? require("@/assets/safe-dig/svg-icons/expired_certificate.svg")
        : "img/svg-icons/expired_certificate.svg";
    },
    activeFilterCount() {
      let count = 0;
      if (this.searchQuery && this.searchQuery.trim() !== "") count++;
      if (this.filters.location_id !== "" && this.filters.location_id !== null) count++;
      if (this.filters.certificateStatus !== "Active Certificates") count++;
      if (this.filters.certificateType !== 0) count++;
      if (this.filters.userType !== 1) count++;
      if (this.isSafeDig && this.includeIndividuals) count++;
      return count;
    },
  },
  watch: {
    searchQuery: function () {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.fetchData();
      }, 300);
    },
    showCertificatePreviewModal(value) {
      if (!value) {
        this.revokeCertificatePreviewBlobUrl();
        this.certificatePreviewUrl = "";
      }
    },
  },
  created() {
    if (localStorage.getItem("hot-token")) {
      this.hot_user = localStorage.getItem("hot-user");
      this.hot_token = localStorage.getItem("hot-token");
    }
    if (localStorage.getItem("hot-user") === "employee") {
      this.editor = "employee";
    } else if (localStorage.getItem("hot-user") === "super-admin") {
      this.editor = "super-admin";
    } else if (localStorage.getItem("hot-user") === "sub-admin") {
      this.editor = "sub-admin";
    } else if (localStorage.getItem("hot-user") === "company-admin") {
      this.editor = "admin";
      this.company_id = localStorage.getItem("hot-user-id");
    } else if (localStorage.getItem("hot-user") === "manager") {
      this.editor = "manager";
    }

    // Security check: Company Admins and Managers should not access Super Admin certificate URLs
    if ((this.editor === "admin" || this.editor === "manager") && this.$route.query.id) {
      // If they're trying to access via direct URL with certificate_id, validate it belongs to their company
      // The backend will handle the actual filtering, but we can add a frontend check here
      // For now, we'll let the backend handle validation since it already filters by company
    }

    if (this.$route.query.id) {
      this.certificate_id = this.$route.query.id;
    }
    if (this.$route.query.course) {
      this.course_id = this.$route.query.course;
      this.filters.certificateStatus = "Active Certificates";
    }
    if (this.$route.query.certificate) {
      this.certificate = this.$route.query.certificate;
    }
    if (this.isSafeDig) {
      this.includeIndividuals = true;
    }
    // this.fetchData();
    this.setDefaultFilterData();
    this.$http
      .post("location/all_company_location", {
        role: this.editor,
      })
      .then((resp) => {
        this.locations = [];
        for (let loc of resp.data) {
          let obj = {
            label: loc.name,
            value: loc.id,
          };
          this.locations.push(obj);
        }
      });
  },
  methods: {
    editCertificateNumber(row) {
      console.log(row);
      this.selectedCertificate = row;
      this.isCertificateEdit = true;
    },
    updateCertificateNumber() {
      if (this.new_certificate_number == "") {
        return Swal.fire({
          title: `Error`,
          html: `Please enter certificate number.`,
          icon: "error",
          confirmButtonClass: "btn btn-success",
        });
      }
      this.$http.post('course/updateCertificateNumber', {
        employee_certifcate_id: this.selectedCertificate.employee_certifcate_id,
        new_certificate_no: this.new_certificate_number
      }).then((res) => {
        if (res.data.status == 1) {
          Swal.fire({
            title: `Success`,
            html: `Certificate number updated successfully.`,
            icon: "success",
            confirmButtonClass: "btn btn-success",
          });
          this.isCertificateEdit = false;
          this.fetchData();
        } else {
          Swal.fire({
            title: `Error`,
            html: `Something went wrong.`,
            icon: "error",
            confirmButtonClass: "btn btn-success",
          });
        }
      });
    },
    isActive(row) {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1;
      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      today = yyyy + "-" + mm + "-" + dd;
      if (row.expiration_date >= today) {
        return true;
      }
    },
    formattedDate(data) {
      return formatDateLocal(data);
    },
    downloadCertificate() {
      this.loading = true;
      this.certificate_ids = [];
      this.course_ids = [];
      this.employee_ids = [];
      for (let data of this.tableData) {
        this.course_ids.push(data.course_id);
        this.employee_ids.push(data.employee_id);
        this.certificate_ids.push(data.certificate_id);
      }

      this.loading = true;

      this.$http.post("user/downloadCertificatePdf", {
        course_id: this.course_ids,
        employee_id: this.employee_ids,
        certificate_id: this.certificate_ids,
        type: "download"
      })
        .then((response) => {
          // If the server returns a JSON like { success: true, zip_url: '...' }
          const data = response.data;
          if (data && data.zip_url) {
            // A zip is an attachment, so pointing the page at it downloads it
            // and leaves the page where it is. A new tab here would be a
            // pop-up: the click that asked for it is long gone.
            downloadFile(data.zip_url);
          } else {
            // Handle unexpected responses here if needed
            console.warn("No zip_url in response!", data);
          }
        })
        .catch((error) => {
          console.error(error);
          // If it's a known error case:
          if (error.response && error.response.status === 422) {
            this.loading = false;
            return Swal.fire({
              title: `Error`,
              html: `Due to security settings, these certificates cannot be included in the mass download.<br>
            Please download these users' certificates individually.`,
              icon: "error",
              confirmButtonClass: "btn btn-success",

            });
          } else {
            // Show a generic error if it's not a 422
            Swal.fire("Error", "An error occurred while downloading the ZIP.", "error");
          }
        })
        .finally(() => {
          // Always hide loading, whether success or error
          this.loading = false;
        });

    },
    fetchData() {
      this.loading = true;
      let self = this;
      this.$http
        .post("course/pass_employee", {
          search: this.searchQuery,
          certificate_status: this.filters.certificateStatus,
          certificate_type: this.filters.certificateType,
          user_type: this.filters.userType,
          include_individuals: this.isSafeDig && this.includeIndividuals ? 1 : 0,
          course_id: this.course_id,
          certificate_id: this.certificate_id,
          interface: "Employee",
          company_id: this.filters.location_id,
          column: this.sortedColumn,
          order: this.order,
          page: this.currentPage,
          per_page: this.perPage
        })
        .then((resp) => {
          let employee_data = resp.data.employee;
          this.totalData = resp.data.total;
          this.tableData = [];
          this.employeeUrl = [];
          this.courseUrl = [];
          this.json_data = [];
          for (let data of employee_data) {
            let obj = [];

            obj = {
              certificate_id: data.employee_certifcate_id,
              employee_id: data.employee_id,
              course_id: data.course_id,
              course_name: data.course_name,
              first_name: data.first_name,
              last_name: data.last_name,
              location: data.company_name,
              certificate_date: data.employee_course_date_completed,
              expiration_date: data.certificate_expiration_date,
              is_proctored_exam: data.is_proctored_exam,
              certificate_url: data.certificate_url,
              show_loader: false,
              is_certificate_approved: data.is_certificate_approved,
              certificate_no: data.certificate_no,
              employee_certifcate_id: data.employee_certifcate_id,
            };
            this.employeeUrl.push(obj.employee_id);
            this.courseUrl.push(obj.course_id);
            this.tableData.push(obj);
            this.course_name = obj.course_name;
            let row = {
              "First Name": data.first_name,
              "Last Name": data.last_name,
              "Course Name": data.course_name,
              "Certificate Name": data.certificate_name,
              "Certificate Date": data.employee_course_date_completed,
              "Certificate Expiry Date": data.certificate_expiration_date,
            };

            this.json_data.push(row);
          }
        })
        .finally(() => (this.loading = false));

      this.$http.post('/course-based-count', {
        course_id: this.course_id,
        certificate_id: this.certificate_id,
        interface: "Employee",
        company_id: this.filters.location_id,
        include_individuals: this.isSafeDig && this.includeIndividuals ? 1 : 0,
      }).then((res) => {
        this.totalCount = res.data.total;
        this.activeCount = res.data.activeCount;
        this.inActiveCount = res.data.inactiveCount;
        // this.uploadedCertificateCount = res.data.uploadedCount;
      });

      this.saveSearchData();
    },
    saveSearchData() {
      localStorage.setItem(
        "all_certificate_detail_search_data",
        JSON.stringify({
          search: this.searchQuery,
          certificate_status: this.filters.certificateStatus,
          course_id: this.course_id,
          certificate_id: this.certificate_id,
          company_id: this.filters.location_id,
          column: this.sortedColumn,
          order: this.order,
        })
      );
    },
    setDefaultFilterData() {
      let previousStateData = JSON.parse(
        localStorage.getItem("all_certificate_detail_search_data")
      );

      if (previousStateData !== null) {
        this.searchQuery = previousStateData.search
          ? previousStateData.search
          : this.searchQuery;
        this.filters.certificateStatus = "Active Certificates";
        // this.filters.certificateStatus = previousStateData.certificate_status
        //   ? previousStateData.certificate_status
        //   : this.filters.certificateStatus;
        this.course_id = this.$route.query.course
          ? this.$route.query.course
          : previousStateData.course_id
            ? previousStateData.course_id
            : this.course_id;
        this.certificate_id = this.$route.query.id
          ? this.$route.query.id
          : previousStateData.certificate_id
            ? previousStateData.certificate_id
            : this.certificate_id;
        this.company_id = previousStateData.company_id
          ? previousStateData.company_id
          : this.company_id;
        this.sortedColumn = previousStateData.column
          ? previousStateData.column
          : this.sortedColumn;
        this.order = previousStateData.order
          ? previousStateData.order
          : this.order;
      }
      this.fetchData();
    },
    resetFilters() {
      this.company_id = "";
      this.filters.certificateStatus = "Active Certificates";
      this.filters.certificateType = 0;
      this.filters.userType = 1;
      this.searchQuery = "";
      this.filters.location_id = "";
      this.includeIndividuals = this.isSafeDig;
      this.sortedColumn = 0;
      this.order = "asc";
      this.fetchData();
    },
    onIncludeIndividualsToggle(enabled) {
      this.includeIndividuals = !!enabled;
      if (this.includeIndividuals) {
        this.filters.location_id = "";
      }
      this.fetchData();
    },
    viewCertificates() {
      this.loading = true;
      this.certificate_ids = [];
      this.course_ids = [];
      this.employee_ids = [];
      for (let data of this.tableData) {
        this.course_ids.push(data.course_id);
        this.employee_ids.push(data.employee_id);
        this.certificate_ids.push(data.certificate_id);
      }

      this.$http
        .post("user/saveCertificatePdf", {
          course_id: this.course_ids,
          employee_id: this.employee_ids,
          certificate_id: this.certificate_ids,
        }, { responseType: 'blob' })
        .then((resp) => {
          this.resultGenerated = true;
          const blob = resp.data; // The blob data returned from the backend
          const url = window.URL.createObjectURL(blob); // Create an object URL for the blob
          const link = document.createElement('a');
          link.href = url;
          link.target = '_blank'; // Open in a new tab
          link.click(); // Trigger the download or display of the PDF in the new tab
          // if (resp.data.user_not_merged) {
          //   Swal.fire({
          //     title: `Error`,
          //     html: "Due to security settings, the following certificates cannot be included in the mass download:</br>" +
          //       resp.data.user_not_merged +
          //       "</br> Please download the above user certificates individually.",
          //     icon: "error",
          //   }).then((result) => {
          //     if (result.value) {
          //       window.open(
          //         this.$baseUrl +
          //         "/employee/certificate_manual/saved_pdf/" +
          //         resp.data.file_name,
          //         "_blank"
          //       );
          //     }
          //   });
          // } else {
          //   window.open(
          //     this.$baseUrl +
          //     "/employee/certificate_manual/saved_pdf/" +
          //     resp.data.file_name,
          //     "_blank"
          //   );
          // }
          // console.log("apiCallled");
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status === 422) {

            this.loading = false;
            return Swal.fire({
              title: `Error`,
              html: `Due to security settings, these certificates cannot be included in the mass download.</br>
                    Please download these users certificates individually.`,
              icon: "error",
              confirmButtonClass: "btn btn-success",

            });
          }
        }).finally(() => (this.loading = false));
    },

    downloadExcel() {
      this.$http
        .post("course/pass_employee", {
          search: this.searchQuery,
          certificate_status: this.filters.certificateStatus,
          course_id: this.course_id,
          certificate_id: this.certificate_id,
          interface: "Employee",
        })
        .then((resp) => {
          let employee_data = resp.data.employee;
          for (let data of employee_data) {
            let obj = [];
            obj = {
              course_name: data.course_name,
            };
          }
          //this.course_name = this.course_name;
          this.items = resp.data.download;
          const data1 = XLSX.utils.json_to_sheet(this.items);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, data1, "data");
          XLSX.writeFile(wb, this.course_name + "Certificate.xlsx");
        })
        .finally(() => (this.loading = false));
    },
    printAllCertificates() {
      this.loading = true;
      this.$http
        .get("course/download_certificate/" + this.course_id)
        .then((resp) => {
          this.download_certificate = true;
          this.download_file_link = resp.data;
        })
        .finally(() => (this.loading = false));
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    getProctoredExamCertificate: function (certificateURL) {
      console.clear();
      console.log(certificateURL);
      let certificateIndex = null;
      this.tableData.forEach(function (certificate, index) {
        if (certificate.certificate_url == certificateURL) {
          certificateIndex = index;
          return true;
        }
      });
      this.tableData[certificateIndex].show_loader = true;
      this.$http
        .post("course/proctored-exam-certificate", {
          certificateURL: certificateURL,
        })
        .then((resp) => {
          this.tableData[certificateIndex].show_loader = false;
          this.openPreviewInModal(resp.data.certificate_url);
        });
    },
    openCertificatePreview(courseId, employeeId, certificateId) {
      const previewUrl = `${this.baseUrl}/downloadCourseCertificate/preview/${courseId}/${employeeId}/${certificateId}`;
      this.openPreviewInModal(previewUrl);
    },
    async openPreviewInModal(previewUrl) {
      this.loading = true;
      this.revokeCertificatePreviewBlobUrl();
      try {
        const resp = await this.$http.get(previewUrl, {
          responseType: "blob",
          headers: {
            Accept: "application/pdf, application/octet-stream, */*",
          },
        });
        const blob = new Blob([resp.data], {
          type: (resp.headers && resp.headers["content-type"]) || "application/pdf",
        });
        const objectUrl = window.URL.createObjectURL(blob);
        this.certificatePreviewBlobUrl = objectUrl;
        this.certificatePreviewUrl = objectUrl;
        this.showCertificatePreviewModal = true;
      } catch (e) {
        Swal.fire({
          title: "Error",
          html: "Could not open certificate preview. Please try again.",
          icon: "error",
          confirmButtonClass: "btn btn-success",
        });
      } finally {
        this.loading = false;
      }
    },
    revokeCertificatePreviewBlobUrl() {
      if (this.certificatePreviewBlobUrl) {
        window.URL.revokeObjectURL(this.certificatePreviewBlobUrl);
        this.certificatePreviewBlobUrl = "";
      }
    },
    approveCertificate: function (certificate) {
      this.$http.post("course/approve-certificate", {
        certificateId: certificate.certificate_id,
      }).then((resp) => {
        certificate.is_certificate_approved = 1;
      });
    },
    emailCertificate: function (certificate) {
      Swal.fire({
        title: 'Are you sure you want to email this user their certificate?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonClass: "btn",
        cancelButtonClass: "btn greybtn",
        confirmButtonColor: "#E0E0E0",
        cancelButtonColor: "",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$http.post("course/email-certificate", certificate).then(() => {
            Swal.fire({
              icon: 'success',
              title: "Success",
              text: "Certificate has been emailed successfully",
              confirmButtonClass: "btn btn-success",
            });
          });
        }
      });
    },
    toggleSlide() {
      this.showContent = !this.showContent;
    }
  },
};
</script>
<style scoped>
.no-border-card .card-footer {
  border-top: 0;
}

.certificate-preview-frame {
  display: block;
  width: 100%;
  min-height: 70vh;
  border: 0;
  background: #525659;
}

.certificate-preview-dialog {
  width: 95vw;
  max-width: 1024px !important;
}

/* ---------- Modern Filter Toggle Button ---------- */
.filters-toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px 18px;
  border-radius: 999px;
  border: 1px solid #d9dce3;
  background: #fff;
  color: #4a5568;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.18s ease;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04);
}

.filters-toggle-btn:hover {
  border-color: #3E7799;
  color: #3E7799;
  box-shadow: 0 2px 6px rgba(94, 114, 228, 0.15);
}

.filters-toggle-btn.is-open {
  background: #3E7799;
  border-color: #3E7799;
  color: #fff;
}

.filters-toggle-btn.is-open:hover {
  background: #356a89;
}

.safedig .filters-toggle-btn:hover {
  border-color: #3E7799;
  color: #3E7799;
  box-shadow: 0 2px 6px rgba(62, 119, 153, 0.2);
}

.safedig .filters-toggle-btn.is-open {
  background: #3E7799;
  border-color: #3E7799;
}

.safedig .filters-toggle-btn.is-open:hover {
  background: #356a89;
}

.filters-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 7px;
  margin-left: 8px;
  border-radius: 999px;
  background: #f56c6c;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}

.filters-toggle-btn.is-open .filters-badge {
  background: #fff;
  color: #5e72e4;
}

/* ---------- Modern Filters Panel ---------- */
.modern-filters {
  background: #fff;
  border: 1px solid #eceff3;
  border-radius: 12px;
  box-shadow: 0 4px 14px rgba(16, 24, 40, 0.04);
  overflow: hidden;
}

.modern-filters__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid #eef0f4;
  background: #fafbfd;
}

.modern-filters__title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #344054;
  font-size: 15px;
}

.modern-filters__title i {
  color: #5e72e4;
}

.safedig .modern-filters__title i {
  color: #3E7799;
}

.modern-filters__reset {
  background: transparent;
  border: 1px solid transparent;
  color: #667085;
  font-size: 13px;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.18s ease;
}

.modern-filters__reset:hover:not(:disabled) {
  background: #f4f5f8;
  color: #344054;
}

.modern-filters__reset:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.modern-filters__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px 18px;
  padding: 20px;
}

.modern-filter {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.modern-filter__label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b7280;
  margin-bottom: 6px;
}

.modern-filter__hint {
  color: #98a2b3;
  font-size: 11px;
  margin-top: 4px;
  font-style: italic;
}

.modern-filter >>> .form-group {
  margin-bottom: 0;
}

.modern-filter >>> .form-control {
  height: 40px;
  border-radius: 8px;
}

.modern-filter >>> .form-control:hover,
.modern-filter >>> .form-control:focus {
  box-shadow: none !important;
}

.modern-filter >>> .input-group {
  align-items: stretch;
}

.modern-filter >>> .input-group-prepend {
  margin-right: 0;
}

.modern-filter >>> .input-group .input-group-text {
  height: 40px;
  border: 1px solid #e3e6ec;
  border-right: 0;
  border-radius: 8px 0 0 8px;
  background: #fff;
  color: #98a2b3;
}

.modern-filter >>> .input-group .form-control {
  border-left: 0;
  border-radius: 0 8px 8px 0;
}

.modern-filter >>> .el-input__inner {
  height: 40px;
  line-height: 40px;
  border-radius: 8px;
  border-color: #e3e6ec;
  font-size: 14px;
  color: #344054;
}

.modern-filter >>> .el-input__inner:focus,
.modern-filter >>> .el-input__inner:hover {
  border-color: #5e72e4;
}

.safedig .modern-filter >>> .el-input__inner:focus,
.safedig .modern-filter >>> .el-input__inner:hover {
  border-color: #3E7799;
}

.modern-filter .w-100 {
  width: 100%;
}

/* ---------- Modern Toggle Switch ---------- */
.modern-filter--toggle {
  justify-content: flex-start;
}

.modern-toggle {
  display: inline-flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  cursor: pointer;
  padding: 10px 12px;
  border: 1px solid #e3e6ec;
  border-radius: 8px;
  background: #fff;
  transition: all 0.18s ease;
  user-select: none;
  height: 40px;
  margin: 0;
}

.modern-toggle:hover {
  border-color: #c7cdd8;
}

.modern-toggle.is-on {
  border-color: #3e7799;
  background: #f0f3ff;
}

.safedig .modern-toggle.is-on {
  border-color: #3E7799;
  background: #edf5fa;
}

.modern-toggle input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  width: 0;
  height: 0;
}

.modern-toggle__track {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;
  background: #d0d5dd;
  border-radius: 999px;
  transition: background 0.18s ease;
  flex-shrink: 0;
}

.modern-toggle__thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.2);
  transition: transform 0.18s ease;
}

.modern-toggle.is-on .modern-toggle__track {
  background: #5e72e4;
}

.safedig .modern-toggle.is-on .modern-toggle__track {
  background: #3E7799;
}

.modern-toggle.is-on .modern-toggle__thumb {
  transform: translateX(16px);
}

.modern-toggle__label {
  font-size: 14px;
  color: #344054;
  font-weight: 500;
  white-space: nowrap;
}

/* ---------- Slide Transition ---------- */
.filters-slide-enter-active,
.filters-slide-leave-active {
  transition: opacity 0.22s ease, transform 0.22s ease, max-height 0.28s ease;
  overflow: hidden;
}

.filters-slide-enter,
.filters-slide-leave-to {
  opacity: 0;
  transform: translateY(-6px);
  max-height: 0;
}

.filters-slide-enter-to,
.filters-slide-leave {
  opacity: 1;
  max-height: 600px;
}

@media (max-width: 576px) {
  .modern-filters__grid {
    grid-template-columns: 1fr;
    padding: 16px;
  }

  .modern-filters__header {
    padding: 12px 16px;
  }
}

@media only screen and (max-width: 1024px),
(min-device-width: 768px) and (max-device-width: 1024px) {
  .certGrid>>>table.el-table__body td:nth-of-type(1):before {
    content: "User";
  }

  .certGrid>>>table.el-table__body td:nth-of-type(2):before {
    content: "Location";
  }

  .certGrid>>>table.el-table__body td:nth-of-type(3):before {
    content: "Completion Date";
  }

  .certGrid>>>table.el-table__body td:nth-of-type(4):before {
    content: "Course";
  }

  .certGrid>>>table.el-table__body td:nth-of-type(5):before {
    content: "Expiration Date";
  }

  .certGrid>>>table.el-table__body td:nth-of-type(6):before {
    content: "Certificate #";
  }

  .certGrid>>>table.el-table__body td:nth-of-type(7):before {
    content: "Actions";
  }
}
</style>
